import IntlProvider from './intl-provider';

export default IntlProvider;
